import { formatDate } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { EventService } from 'src/app/core/services/event.service';
import { SharedService } from 'src/app/core/services/shared.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'sidebar-avatar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarAvatarComponent implements OnInit {

  @Input() url;
  @Input() templates;
  @Input() encabezado = [];
  @Input() operaciones = [];
  @Input() llaves = [];
  @Input() encabezadoSYS02CON;

  @Output() toggle = new EventEmitter<boolean>();
  @Output() actualizar = new EventEmitter();

  form_template = [];
  strModoCampo: string;
  ToolbarMS = [];
  SYS02CON = '';

  myFormGroup: FormGroup = null;
  strWsURLModal: string = "";
  strTituloPantallaModal: string = "";
  scriptElement: any;
  modal_element_label: string;
  modal_element_type: string;
  strSYS03JAV: string = "";
  copiallaves: Array<any> = [];
  CNT05COD: any;
  formespecial = [];
  formcardhidden = [];
  cardsNuevos = [];
  alturaCard: number;

  public Editor = Editor;
  isCollapsed = false;


  constructor(private dataService: SharedService, private modalService: NgbModal, private eventService: EventService) { }

  ngOnInit(): void {
    if (this.url != "") {
      let json = { LLAVES: [], OPERACION: 'SELECT' }
      let campos = new Object();
      for (const template of this.templates) {
        for (const card of template.cards) {
          campos[card.label] = card.value;
        }
      }
      json.LLAVES.push(campos);

      this.dataService.ConsultarWS(this.url, JSON.stringify(json)).subscribe((datos) => {
        this.form_template = datos.CamposMS;
        this.strModoCampo = datos.Modo;
        this.ToolbarMS = datos.Toolbar;
        this.SYS02CON = datos.SYS02CON;
        this.CrearFormulario();
      });
    }
  }

  CrearFormulario() {
    let group = {};
    if (this.form_template !== undefined && this.form_template != null) {
      this.form_template.forEach((itemCard) => {
        let card = itemCard.cards;
        if (card !== undefined && card != null) {
          card.forEach((item) => {
            let valor = item.value;
            if (item.type == "textbox_date" && valor != "") {
              valor = formatDate(valor, "yyyy-MM-dd", "en");
            }

            if (item.type == "checkbox" && valor == item.CheckBoxFalse) {
              valor = false;
            }
            let validores = [];
            if (item.validators.required) {
              validores.push(Validators.required);
            }
            if (item.type == "email") {
              validores.push(Validators.email);
            }

            group[item.label] = new FormControl(
              { value: valor, disabled: false }, validores
            );

            if (item.SYS03ALI != undefined) {
              this.formespecial[item.label] = item.SYS03ALI;
            }

            if (item.SYS03JAV !== undefined) {
              if (item.SYS03JAV != "") {
                this.strSYS03JAV =
                  this.strSYS03JAV + "\n\n" + atob(item.SYS03JAV);
              }
            }
          });
        }
      });
    }
    this.myFormGroup = null;
    this.myFormGroup = new FormGroup(group);
    this.copiallaves.push(this.myFormGroup.value);
  }

  RetornoModal(event) {
    if (event.length > 0) {
      let retorno = event[0];
      let cambios = [];
      let claves = Object.keys(retorno);
      claves.forEach((key) => {
        if (key == "TSTAMP") {
          key = this.myFormGroup.value.TSTAMP;
        } else if (this.modal_element_label == key) {
          const formControl = this.myFormGroup.get(key);
          if (formControl) {
            formControl.setValue(retorno[key]);
            cambios.push({ label: key, valor: retorno[key], parametro: 1 });
          }
        } else if (this.modal_element_label != key) {
          if (this.TienePropiedad(key)) {
            if (claves.length <= 2) {
              const formControl = this.myFormGroup.get(this.modal_element_label);
              formControl.setValue(retorno[key]);
              cambios.push({ label: this.modal_element_label, valor: retorno[key], parametro: null });
            } else {
              const formControl = this.myFormGroup.get(key);
              formControl.setValue(retorno[key]);
              cambios.push({ label: key, valor: retorno[key], parametro: null });
            }
          } else {
            const formControl = this.myFormGroup.get(key);
            formControl.setValue(retorno[key]);
            cambios.push({ label: key, valor: retorno[key], parametro: 1 });
          }
        }
      });

      if (this.modal_element_type == "select_url") {
        for (const i in cambios) {
          let elemento = this.getElemento(cambios[i].label);
          if (elemento.url_select != null) {
            this.SelectURL_Change(this.getElemento(cambios[i].label), null, cambios[i].valor, cambios[i].parametro);
          }
        }
      }
    }

    this.modalService.dismissAll();
  }

  getElemento(label) {
    for (const i in this.form_template) {
      for (const j in this.form_template[i].cards) {
        if (this.form_template[i].cards[j].label == label) {
          return this.form_template[i].cards[j];
        }
      }
    }
  }

  TienePropiedad(propiedad) {
    for (const key in this.formespecial) {
      if (this.formespecial[key] == propiedad && key == this.modal_element_label) {
        return true;
      }
    }
    return false;
  }

  EventoClickMS(obj, boton) {

    if (boton.Evento == "IMPRIMIR" || boton.Evento == "IMPRIMIR_FIRMAR") {  
      this.VerReporte(this.encabezadoSYS02CON, boton.SYS10CON, boton.SYS16CON, "PDF", boton.URL, boton.Evento)
    } else{
      if (this.myFormGroup.valid) {
        let llaves = [];
        llaves.push(this.myFormGroup.value);
        let comparacion = JSON.stringify(this.copiallaves) === JSON.stringify(llaves);
  
        llaves[0] = this.formatearFormulario(llaves[0]);
        llaves = this.agregarArchivos(llaves);
        var jsonFiltros = this.toJSON(boton.Evento, llaves, boton.URL);
        let btn = document.getElementById('campo2'+boton.Evento) as HTMLButtonElement;
        if (boton.Evento != "UPDATE_GENERICO") comparacion = false;
        if (comparacion == false && ('campo2'+boton.Evento == "campo2_" + boton.Evento)) {
          btn.disabled = true;
          var operacion = "";
          if (boton.Evento == "INSERT_GENERICO") operacion = "Campo Insertados";
          else if (boton.Evento == "UPDATE_GENERICO") operacion = "Campo Actualizados";
          this.dataService.ConsultarWS(boton.URL, jsonFiltros).subscribe((datosResp: any) => {
            this.actualizar.emit();
            Swal.fire({
              position: "top-end",
              toast: true,
              icon: "success",
              text: operacion + " Correctamente",
              showConfirmButton: false,
              timer: 5000,
            });
            btn.disabled = false;
          },
            (error) => {
              Swal.fire({
                html:
                  '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                  '<div class="col-5">' +
                  ' <img src="assets/images/imageerror.png"> </img>' +
                  "</div>" +
                  ' <div class="col-7">' +
                  "<h3>Error</h3><br>" +
                  " <p>" +
                  error +
                  "</p>" +
                  " </div> ",
              });
              btn.disabled = false;
            }
          );
        } else {
          if (boton.Evento == "UPDATE_GENERICO") {
            Swal.fire({
              html:
                '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                '<div class="col-5">' +
                ' <img src="assets/images/imageerror.png"> </img>' +
                "</div>" +
                ' <div class="col-7">' +
                "<h3>Error</h3><br>" +
                " <p>No se han encontrado cambios</p>" +
                " </div> ",
            });
          }
        }
      } else {
        const invalid = [];
        const controls = this.myFormGroup.controls;
        for (const name in controls) {
          if (controls[name].invalid) {
            invalid.push(name);
          }
        }
        this.form_template.forEach((input_template) => {
          for (let i = 0; i < input_template.cards.length; i++) {
            for (let j = 0; j < invalid.length; j++) {
              if (invalid[j] == input_template.cards[i].label) {
                invalid[j] = input_template.cards[i].title;
              }
            }
          }
        });
        Swal.fire({
          html:
            '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
            '<div class="col-5">' +
            ' <img src="assets/images/imageerror.png"> </img>' +
            "</div>" +
            ' <div class="col-7">' +
            "<h3>Error</h3><br>" +
            " <p>Por favor verifique los campos requeridos: </p>" +
            "<p>" +
            invalid.join(", ") +
            "</p>" +
            " </div> ",
        });
      }
    }
    
  }

  SelectURL_Change(elemt, evento, value, parametro = null) {
    let valor = "";
    if (value != null) {
      valor = value;
    } else {
      valor = evento.target.value;
    }
    if (valor === "") {
    } else {
      for (const key2 in this.myFormGroup.value) {
        if (this.myFormGroup.value[key2] === false) {
          this.myFormGroup.value[key2] = "false";
        }
      }

      let llavesdes = [];
      llavesdes.push(JSON.parse(JSON.stringify(this.myFormGroup.value)));

      if (elemt.SYS03ALI != "" && elemt.SYS03ALI != undefined && parametro != 1) {
        llavesdes[0][elemt.SYS03ALI] = valor;
      }

      // Ejecuto la operacion en el backend
      var jsonFiltros = this.toJSON(
        "BUSCAR_DESCRIPCION",
        llavesdes,
        elemt.url_select
      );

      this.dataService.ConsultarWS(elemt.url_select, jsonFiltros).subscribe(
        (datosResp: any) => {

          if (datosResp.CamposMS != undefined) {
            if (datosResp.CamposMS.length > 0) {
              for (const key in datosResp.CamposMS) {
                let encontro = false;
                for (const key1 in this.formcardhidden) {
                  if (
                    datosResp.CamposMS[key].descripcion ==
                    this.formcardhidden[key1].descripcion
                  ) {
                    encontro = true;
                    this.formcardhidden[key1] = datosResp.CamposMS[key];
                    this.formcardhidden[key1].idCard = datosResp.SYS02CON;
                    break;
                  }
                }
                if (encontro == false) {
                  let fila = datosResp.CamposMS[key];
                  fila.idCard = datosResp.SYS02CON;
                  this.formcardhidden.push(fila);
                }
              }
              for (const i in this.cardsNuevos) {
                for (const j in this.formcardhidden) {
                  for (const k in this.formcardhidden[j].cards) {
                    if (
                      this.formcardhidden[j].cards[k].label ==
                      this.cardsNuevos[i].label
                    ) {
                      if (this.strModoCampo == "INSERT") {
                        this.myFormGroup.get(this.formcardhidden[j].cards[k].label).setValue(this.formcardhidden[j].cards[k].value);
                        this.CboClick(this.cardsNuevos[i]);
                        if (
                          elemt.SYS03CDE ==
                          this.formcardhidden[j].cards[k].label
                        ) {
                          document.getElementById(elemt.SYS03CDE).innerHTML =
                            this.formcardhidden[j].cards[k].value;
                        }
                      }

                      if (
                        this.formcardhidden[j].cards[k].type ==
                        this.cardsNuevos[i].type
                      ) {
                        this.cardsNuevos[i].options =
                          this.formcardhidden[j].cards[k].options;
                      }
                      this.formcardhidden[j].cards.splice(k, 1);
                    }
                  }
                }
              }

              for (const i in this.formcardhidden) {
                for (const j in this.form_template) {
                  if (
                    this.form_template[j].idCard ==
                    this.formcardhidden[i].idCard &&
                    this.form_template[j].idCard == datosResp.SYS02CON
                  ) {
                    for (const k in this.formcardhidden[i].cards) {
                      let indice = this.form_template[j].cards.findIndex(
                        (x) =>
                          x.label ==
                          "span_" + this.formcardhidden[i].cards[k].label
                      );
                      if (indice == -1) {
                        let fila = this.formcardhidden[i].cards[k];
                        fila.label = "span_" + fila.label;
                        this.form_template[j].cards.push(fila);
                        this.myFormGroup.addControl(
                          fila.label,
                          new FormControl(
                            {
                              value: this.formcardhidden[i].cards[k].value,
                              disabled: false,
                            },
                            []
                          )
                        );
                      } else {
                        this.form_template[j].cards[indice] =
                          this.formcardhidden[i].cards[k];
                        this.form_template[j].cards[indice].label =
                          "span_" + this.form_template[j].cards[indice].label;
                        this.myFormGroup
                          .get(this.form_template[j].cards[indice].label)
                          .setValue(this.formcardhidden[i].cards[k].value);
                      }
                    }
                    break;
                  }
                }
              }
            }
          } else {
            for (var clave in datosResp.DATA[0]) {
              let descripcion = datosResp.DATA[0][clave];
              if (elemt.SYS03CDE != "") {
                elemt.labeldes = descripcion;
              }
            }
          }
        },
        (error) => {
          Swal.fire({
            html:
              '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
              '<div class="col-5">' +
              ' <img src="assets/images/imageerror.png"> </img>' +
              "</div>" +
              ' <div class="col-7">' +
              "<h3>Error</h3><br>" +
              " <p>" +
              error +
              "</p>" +
              " </div> ",
          });
        }
      );
    }
  }

  CboClick(elemento) {
    if (elemento.ComboClick == "S") {
      this.form_template.forEach((input_template) => {
        for (let i = 0; i < input_template.cards.length; i++) {
          if (input_template.cards[i].label == elemento.ComboClickDestName) {
            let llaves = JSON.stringify(this.myFormGroup.value);
            let jsonFiltros = JSON.parse('{ "LLAVES"   : [' + llaves + "]}");
            this.dataService.Ejecutar("api/mantenimientos/ListarCombo/" + input_template.cards[i].ComboClickURL, jsonFiltros).subscribe(
              (datosResp: any) => {
                input_template.cards[i].options = datosResp;
                input_template.cards[i].value = "";
              },
              (error) => {
                Swal.fire({
                  html:
                    '<div class="row align-items-center" style="width:100%; overflow:auto;"> ' +
                    '<div class="col-5">' +
                    ' <img src="assets/images/imageerror.png"> </img>' +
                    "</div>" +
                    ' <div class="col-7">' +
                    "<h3>Error</h3><br>" +
                    " <p>" +
                    error +
                    "</p>" +
                    " </div> ",
                });
              }
            );
          }
        }
      });
    }
  }

  cargarCombo(evento, elemento) {
    if (elemento.ComboPrecargado == "S") {
      if (evento.term.length > 2) {
        let parametros = { LLAVES: [{ FILTRO: evento.term }] };
        this.dataService.ConsultarWS("api/mantenimientos/ListarCombo/" + elemento.ComboClickURL, JSON.stringify(parametros)).subscribe((datos: any) => {
          elemento.options = datos.DATA;
        }, (err: any) => {

        });
      }
    }
  }

  AbrirModal(contenido, elemento) {
    this.modal_element_label = elemento.label;
    this.modal_element_type = elemento.type;


    this.strWsURLModal = "api/mantenimientos/ListarGenerico/" + elemento.id_modal;
    this.strTituloPantallaModal = elemento.titulo_modal;
    this.modalService.open(contenido, { size: "xl" });

  }

  ValidarFormulario() {
    if (this.myFormGroup.valid) {
      let objForm = this.formatearFormulario(this.myFormGroup.value);
      this.eventService.broadcast(
        "EVENTO_REFRESAR_LISTA_" + this.SYS02CON,
        JSON.stringify(objForm)
      );
    } else {
      alert("campos necesarios");
    }

  }

  formatearFormulario(form) {
    for (const key in form) {
      if (form[key] == null) {
        form[key] = "";
      }
      if (Array.isArray(form[key])) {
        form[key] = "'" + form[key].join("','") + "'";
      }

      if (form[key] === true || form[key] === false) {
        for (const i in this.form_template) {
          for (const j in this.form_template[i].cards) {
            if (this.form_template[i].cards[j].label == key) {
              if (form[key] === true) {
                form[key] = this.form_template[i].cards[j].CheckBoxTrue;
              } else if (form[key] === false) {
                form[key] = this.form_template[i].cards[j].CheckBoxFalse;
              }
              break;
            }
          }
        }
      }
    }

    return form;
  }

  onSelect(event, elemento) {
    for (const iterator of event.addedFiles) {
      const reader = new FileReader();
      reader.readAsDataURL(iterator);
      reader.onload = () => {
        iterator.base64 = reader.result;
        iterator.nombre = iterator.name;
        iterator.tipo = iterator.type;
        elemento.files.push(iterator);
      };
    }
  }

  onRemove(event, elemento) {
    elemento.files.splice(elemento.files.indexOf(event), 1);
  }

  agregarArchivos = function (llaves: any[]): any[] {
    
    let adjuntos = [];
    for (const i in this.form_template) {
      for (const j in this.form_template[i].cards) {
        if (this.form_template[i].cards[j].files != undefined) {
          adjuntos.push(...this.form_template[i].cards[j].files);
        }
      }
    }

    if (adjuntos.length > 0){
      llaves[0].adjuntos = adjuntos;
    }

    return llaves;
  }

  toJSON(operacion: string, arr: any[], url?: string, extra?: string) {
    return JSON.parse(
      '{ "LLAVES"   :' +
      JSON.stringify(arr) +
      (url != null ? ', "URL"      :"' + url + '"' : "") +
      (extra != null ? "," + extra : "") +
      ', "OPERACION":"' +
      operacion +
      '"}'
    );
  }

  toggleSidebar() {
    this.isCollapsed = !this.isCollapsed;
    this.toggle.emit(this.isCollapsed);
  }

  VerReporte(intSYS02CON: number, intSYS10CON: string, strSYS16CON: string, strFORMATO: string, url: string, evento: string) {
    url = (url == undefined ? "api/mantenimientos/VerReporte/" + intSYS02CON : url);
    let strjson = "{      \"FILTROS_OPCIONALES\"   : []" +
      " , \"SYS02CON\"   : \"" + intSYS02CON + "\" " +
      " , \"SYS10CON\"   : " + intSYS10CON +
      " , \"SYS16CON\"   : " + strSYS16CON +
      " , \"FORMATO\"    : \"" + strFORMATO + "\" " +
      " , \"TITULO\"     : \"\"" +
      " , \"FILTROS_OBLIGATORIOS\" : [" + JSON.stringify(this.llaves) + "]}";
    let arr = JSON.parse(strjson);
    let json = this.toJSON(evento, arr, url + "/" + intSYS10CON + "/" + strSYS16CON);
    this.dataService.ConsultarWS(url + "/" + intSYS10CON + '/' + strSYS16CON, json).subscribe(
      (datosResp: any) => {
        if (evento == 'IMPRIMIR') {
          const base64 = datosResp.DATA[0].REPORTE_PDF_BASE64;
          const blob = this.dataURItoBlob(base64, strFORMATO);
          let fileURL = URL.createObjectURL(blob);
          window.open(fileURL, '_blank');
        }
      },
      error => {
        Swal.fire({
          title: 'Error',
          text: error,
          icon: 'error',
        })
      }
    );
  }

  dataURItoBlob(dataURI, strFORMATO) {
    let strType = "application/pdf";
    if (strFORMATO == "XLS") strType = "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: strType });
    return blob;
  }

}
